import {
  GetAnualidadProyectosOptions,
  PostCalcularComisionesSemestral,
  GetCalculoSemestralAceptable,
  State as ComisionAnualidadState
} from "../../../reducers/comisionAnualidad";

export interface ProcesoSemestralStore
  extends GetAnualidadProyectosOptions,
    PostCalcularComisionesSemestral,
    GetCalculoSemestralAceptable {}

export const procesoSemestralStore: (
  state
) => ProcesoSemestralStore = state => {
  const comisionAnualidad: ComisionAnualidadState = state.comisionAnualidad;

  return {
    anualidadProyectosOptions: comisionAnualidad.anualidadProyectosOptions,
    gettingAnualidadProyectosOptions:
      comisionAnualidad.gettingAnualidadProyectosOptions,
    gettingAnualidadProyectosOptionsError:
      comisionAnualidad.gettingAnualidadProyectosOptionsError,

    calcularComisionesSemestralResult:
      comisionAnualidad.calcularComisionesSemestralResult,
    postingCalcularComisionesSemestral:
      comisionAnualidad.postingCalcularComisionesSemestral,
    postingCalcularComisionesSemestralError:
      comisionAnualidad.postingCalcularComisionesSemestralError,

    calculoSemestralAceptable: comisionAnualidad.calculoSemestralAceptable,
    gettingCalculoSemestralAceptable:
      comisionAnualidad.gettingCalculoSemestralAceptable,
    gettingCalculoSemestralAceptableError:
      comisionAnualidad.gettingCalculoSemestralAceptableError
  };
};
